import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=113af33f&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=113af33f&prod&lang=scss&"
import style1 from "./TaskList.vue?vue&type=style&index=1&id=113af33f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113af33f",
  null
  
)

export default component.exports